import { 
    Box,
    Typography,
    IconButton,
    Button,
    Card,
    Collapse,
    CardHeader,
    Container,
    CardContent,
} from "@mui/material";

import Avatar from '@mui/material/Avatar';

import AddIcon from '@mui/icons-material/Add';

import Badge from "@mui/material/Badge";

import Tooltip from "@mui/material/Tooltip";

import { useGoogleLogin } from '@react-oauth/google';
import { googleScopes } from "constants/googleAuth";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import { handleGoogleLinkResponse } from "utils/googleAuth";
import KeyboardArrowDownIcon from 
    "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from 
    "@mui/icons-material/KeyboardArrowUp";
import DeleteIcon from '@mui/icons-material/Delete';

import { third_party_constants } from "constants/third_party_constants";
import { AvatarGroup } from '@mui/material';


// table imports
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const HandleGoogleClick = ({ scope, email, icon }) => {
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    
    const scopes = {
        google_calendar: "https://www.googleapis.com/auth/calendar",
        google_drive: "https://www.googleapis.com/auth/drive",
        google_people: "https://www.googleapis.com/auth/contacts.readonly",
    }

    const handleGoogleClick = useGoogleLogin({
        onSuccess: ({ code }) => handleGoogleLinkResponse({ code, token, dispatch }),
        flow: 'auth-code',
        scope: scope ? scopes[scope] : googleScopes, // space seperated string of scopes
        hint: scope ? email : undefined,
    })

    return (
        scope === undefined ? (
            <Button 
                variant="contained" 
                color="primary" 
                onClick={handleGoogleClick}
                startIcon={<AddIcon />}
                sx={{ textTransform: "none" }}
            >
                <Typography variant="secondary">
                    Add Workspace
                </Typography>
            </Button>
        ) : (
            <Tooltip title={scope.name}>
                <IconButton
                    onClick={handleGoogleClick}
                >
                    <Badge badgeContent={"+"} color="success">
                        { icon }
                    </Badge>
                </IconButton>
            </Tooltip>
        
        )
    )
}

const IntegrationCard = ({ integrationType, data }) => {
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(data.length > 0);

    const handleMicrosoftClick = () => {
        console.log("microsoft");
    };

    const removeIntegration = () => {
        console.log("remove token");
    };
    /**
     * TODO: 
     * make service icons bigger
     * current services: rid of background, no overlay, and have button to remove to right of services 
     * decrease font
     * 
     */

    const integration = third_party_constants[integrationType];

    return(
        <Box pb="2rem" style={{ width: "80%" }}>
            {/* GOOGLE */}

            <Card sx = {{ minWidth: 275, borderRadius: '16px', background: data.length === 0 ? "#e4e1e6" : undefined }}>
                <CardHeader
                    avatar={
                        integration.icon({ fontSize: "large" })
                    }
                    title={
                        // if no data, then show "No Workspaces Integrated" and darken it out, else leave as background color and show "X Workspaces Integrated"
                        <Typography variant="h5" color={data.length === 0 ? "textSecondary" : undefined}>
                            {data.length === 0 ? "No" : data.length} Workspaces Integrated
                        </Typography>
                    }
                    action={
                        <Box>
                            {integrationType === "google" && 
                                // if the integration is google, use HandleGoogleClick component
                                <HandleGoogleClick scope={undefined} email={undefined} icon={undefined} />
                            }
                            {integrationType === "microsoft" && 
                                // if the integration is microsoft, use HandleMicrosoftClick function and create button
                                // TODO: maybe just change HandleGoogleClick to HandleClick and pass type as prop
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    onClick={handleMicrosoftClick}
                                    startIcon={<AddIcon />}
                                    sx={{ textTransform: "none" }}
                                >
                                    <Typography variant="secondary">
                                        Add Workspace
                                    </Typography>
                                </Button>
                            }
                                                        
                            <IconButton
                                // if no data, disable the button, else default to collapse open
                                disabled={data.length === 0}
                                onClick={() => setOpen(!open)}
                                arial-label="expand"
                                size="large"
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </Box>
                    }
                ></CardHeader>

                {data.length > 0 && (
                    // if data exists, show the table of workspaces
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <CardContent>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="h5">
                                                Profile
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant="h5">
                                                Email
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant="h5">
                                                Current Services
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant="h5">
                                                Missing Services
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant="h5">
                                                Actions
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {data?.map((row) => (
                                        // for each workspace, create a row in the table
                                        <TableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            {/* profile picture. TODO: chamge profile picture functionality */}
                                            <TableCell component="th" scope="row">
                                                <Avatar alt="Remy Sharp" src={row.profile} />
                                            </TableCell>

                                            {/* email */}
                                            <TableCell align="left">{row.email}</TableCell>

                                            {/* current scopes */}
                                            <TableCell align="left">
                                                {/* create avatar group of all scopes */}
                                                <Box display="flex" alignItems="left" gap="0.5rem">
                                                    <Tooltip title="Remove Services">
                                                        <Badge badgeContent={"-"} color="error" overlap="circular">
                                                            <AvatarGroup 
                                                                max={3} 
                                                                spacing={15} 
                                                                onClick={removeIntegration}
                                                                sx={[
                                                                    (theme) => ({
                                                                        '&:hover': {
                                                                            cursor: "pointer",
                                                                            boxShadow: theme.shadows[4],
                                                                            // bgcolor: "transparent"
                                                                        },
                                                                    }),
                                                                    {".MuiAvatar-root" : { border: 0 }},
                                                                    {borderRadius: "1000%"}
                                                                ]}
                                                            >
                                                                {row?.current_scopes?.map((scope) => (                                                                
                                                                        <Avatar children={scope.icon({ fontSize: "medium" })} sx={{ bgcolor:"primary", ".MuiAvatarGroup-avatar" : { border: 0 } }} />
                                                                    
                                                                ))}
                                                            </AvatarGroup>
                                                        </Badge>
                                                    </Tooltip>
                                                </Box>
                                                
                                            </TableCell>

                                            {/* missing scopes */}
                                            <TableCell align="left">
                                                    {integrationType === "google" && (
                                                        row?.missing_scopes?.map((scope) => (
                                                            <HandleGoogleClick scope={scope} email={row.email} icon={scope.icon({ fontSize: "medium" })} />
                                                        ))
                                                    )}
                                            </TableCell>

                                            {/* actions */}
                                            <TableCell align="left">
                                                <Tooltip title={row.actions ? "Cannot Delete SignUp Workspace!" : "Delete Workspace"} >
                                                    <span>
                                                        <IconButton
                                                            onClick={() => console.log("delete integration")}
                                                            disabled={row.actions}
                                                            color="error"
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>                                                
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Collapse>
                )}
            </Card>

        </Box>
    )
}

export default IntegrationCard;